import { Modal, type ModalProps } from 'antd';

/**
 * Keeps declarative modal content mounted so form and complex content do not
 * mount during the entrance transition. Data still resets when callers open it.
 */
export function StableModal({ className, forceRender = true, destroyOnHidden = false, transitionName = '', ...props }: ModalProps) {
  return (
    <Modal
      {...props}
      className={['stable-modal', className].filter(Boolean).join(' ')}
      forceRender={forceRender}
      destroyOnHidden={destroyOnHidden}
      transitionName={transitionName}
    />
  );
}
